import GreytSpaceLogo from "./GreytSpace.png";
import GoalAchievement from "./goal-achievement.png";
import technology from "./technology.png";
import cloud_technology from "./cloud-technology.png";
import AI_ML from "./AI-ML.png";
import support_maintenance from "./support-maintenance.png";
import development from "./development.png";
import GreytSpace_IMG from "./GreytSpace-img.png";
import chatbots from "./chatbots.png";
import PaymentDashboardImg from "./Payment-Dashboard-Img.png";
import WhatsappServices from "./whatsapp-services.png";
import contactUs from "./contact-us.png";
import aboutUs from "./about-us.png";
import connectPeople from "./connect-people.png";
import supportPeople from "./customer-relationship-management.jpg";
import connectBots from "./connect-bots.png";
import timesheet from "./timesheet.png";
import accountant from "./accountant.png";
import support_help_desk from "./Emails-bro.svg";

const IMAGES = {
  GreytSpaceLogo,
  technology,
  GoalAchievement,
  cloud_technology,
  AI_ML,
  support_maintenance,
  development,
  GreytSpace_IMG,
  chatbots,
  PaymentDashboardImg,
  WhatsappServices,
  contactUs,
  aboutUs,
  connectPeople,
  connectBots,
  timesheet,
  accountant,
  support_help_desk,
  supportPeople,
};

export default IMAGES;
